export const enum PaymentProvider {
  PayPal = 1,
  Alipay = 3,
  WeChat = 4,
}

export const enum PaymentCurrency {
  USD = 'USD',
  CNY = 'CNY',
}

export const enum PaymentScene {
  PAYPAL_OR_ALIPAYH5 = 1, // 根据设备自动选择 PayPal 或支付宝 H5 支付
  ALIPAY_PC = 3, // 支付宝移动端
}

export const enum PaymentStatus {
  Unpaid = 0,
  Processing = 1,
  Paid = 2,
  Refunded = 3,
  Failed = 4,
  Cancelled = 5,
}

export const enum PayMode {
  PayPalJsSdk = 'PayPalJsSdk',
}
